import { MailFile } from '@ukpostbox/client-data/lib/Types/MailFileTypes';
import { StackedThumbnails } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/StackedThumbnails';
import { MailItemThumbnail } from '../../Thumbnails/Entries/MailItemThumbnail';
import { MailItemNoThumbnail } from '../../Thumbnails/Entries/MailItemNoThumbnail';
import { MailPartTypeEnum } from '../../Thumbnails/Types/ThumbnailTypes';

function ForwardingBatchContents(props: MailFile) {
	return props.userFileThumbnails && props.userFileThumbnails.length > 0 ? (
		<StackedThumbnails>
			{props.userFileThumbnails.map((file) => (
				<MailItemThumbnail key={`forwardingBatchContentsThumb${file.fileName}`} {...file} />
			))}
		</StackedThumbnails>
	) : (
		<MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']} />
	);
}

export { ForwardingBatchContents };
